import { Type } from '@scalar/typebox';
/**
 * Work around for: https://github.com/sinclairzx81/typebox/issues/1264
 */
export const compose = (...args) => {
    return Type.Composite(args);
};
